module.exports = __webpack_public_path__ + "static/img/iphone_msptitle3.c6c74f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_msptitle3.png
// module id = AFq3
// module chunks = 0